import type {
    ICategoryTrafficData,
    IPeriodOverPeriodCategoryTrafficData,
} from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import { COMMON_COLORS } from "app/pages/industry-analysis/common/commonColors";

export const CHART_HEIGHT = 297;

export const MAX_COLUMNS_TO_DISPLAY = 10;
export const TRAFFIC_METRIC: keyof ICategoryTrafficData = "AvgVisits";
export const PREVIOUS_PERIOD_TRAFFIC_METRIC: keyof IPeriodOverPeriodCategoryTrafficData = "PrevAvgVisits";
export const CHANGE_METRIC: keyof ICategoryTrafficData = "VisitsChange";

export const COLORS = COMMON_COLORS;
